export default __webpack_public_path__ + "static/media/Chernikov_Mikhail_Yuryevich.8e9866c3.webp";